import { useEffect, useMemo, useState } from 'react';
import api from '../api';
import { useApp } from '../App';

const MERCHANT_ROLES = new Set(['company_admin', 'company_owner', 'admin', 'superadmin']);

export default function OffersList() {
  const { setPage, user } = useApp();
  const isMerchant = useMemo(() => MERCHANT_ROLES.has(user?.role), [user]);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadOffers();
  }, []);

  async function loadOffers() {
    try {
      setLoading(true);
      const url = isMerchant ? '/marketplace/offers' : '/marketplace/offers?status_filter=open';
      const { data } = await api.get(url);
      setOffers(data || []);
    } catch (e) {
      setError(e.userMessage || 'Не удалось загрузить офферы');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="page-header">Marketplace</div>
      <div className="card" style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
          <button className="btn" onClick={() => window.open('https://genro.ai', '_blank', 'noopener,noreferrer')}>Open in Genro AI</button>
          <button className="btn btn-primary" onClick={() => setPage('dashboard')}>Process in Workify CRM</button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
          <div>{isMerchant ? 'Ваши офферы и статус сделок' : 'Доступные заказы для креаторов'}</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn" onClick={loadOffers}>Обновить</button>
            {isMerchant && <button className="btn btn-primary" onClick={() => setPage('offer_publish')}>+ Publish Offer</button>}
          </div>
        </div>
      </div>

      {loading && <div className="card">Загрузка...</div>}
      {error && <div className="card" style={{ color: '#ef4444' }}>{error}</div>}

      {!loading && !offers.length && <div className="card">Пока нет открытых офферов</div>}

      {offers.map((offer) => (
        <div key={offer.id} className="card" style={{ marginBottom: 10 }}>
          <div style={{ fontWeight: 700 }}>{offer.title}</div>
          <div style={{ opacity: 0.75, fontSize: 13, marginTop: 4 }}>{offer.description || 'Без описания'}</div>
          <div style={{ marginTop: 8 }}>
            💰 {offer.budget_amount} {offer.currency} · комиссия: {offer.commission_type === 'percent' ? `${offer.commission_rate}%` : `${offer.commission_flat_amount || 0} ${offer.currency}`}
          </div>
          <button className="btn btn-primary" style={{ marginTop: 10 }} onClick={() => { localStorage.setItem('marketplace_offer_id', String(offer.id)); setPage('offer_details'); }}>
            Открыть
          </button>
        </div>
      ))}
    </div>
  );
}
